import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import MyButton from '../../../utils/MyButton';
import { FaArrowCircleLeft } from 'react-icons/fa';
import './MobiliarioHome.css';
import TablaMobiliario from './TablaMobiliario';

function MobiliarioHome(props) {
  const history = useHistory();
  const { clienteId } = useParams();
  const { user } = props;

  const handleGoBack = () => {
    const tipouser = user.credentials.tipouser;

    if (tipouser === "Tecnico") {
      history.push(`/dashboard/perfilclientetec/${clienteId}`);
    } else {
      history.push(`/dashboard/perfilcliente/${clienteId}`);
    }
  };

  return (
    <div>
      <div className="titulo_section">
        <div className="titulo_clientes">
          <h1 className="text-clientes">Otros Activos</h1>
          <hr className="clientes_separator" />
        </div>

        <div className="div_boton">
          <MyButton tip="Volver" onClick={handleGoBack}>
            <FaArrowCircleLeft color="#03178C" className="icon-eliminarcliente" />
          </MyButton>
        </div>
      </div>

      <div className="container-inventario-perfil">
        <TablaMobiliario clienteId={clienteId} />
      </div>
    </div>
  );
}

MobiliarioHome.propTypes = {
  user: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  user: state.user
});

export default connect(mapStateToProps)(MobiliarioHome);